import { render, staticRenderFns } from "./SearchFilterTokens.vue?vue&type=template&id=3335fd1f&scoped=true&"
import script from "./SearchFilterTokens.vue?vue&type=script&lang=js&"
export * from "./SearchFilterTokens.vue?vue&type=script&lang=js&"
import style0 from "./SearchFilterTokens.vue?vue&type=style&index=0&id=3335fd1f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3335fd1f",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3335fd1f')) {
      api.createRecord('3335fd1f', component.options)
    } else {
      api.reload('3335fd1f', component.options)
    }
    module.hot.accept("./SearchFilterTokens.vue?vue&type=template&id=3335fd1f&scoped=true&", function () {
      api.rerender('3335fd1f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2uAtIBOO0Bat4/JS/comp/SearchFilterTokens.vue"
export default component.exports